/* template */
<template><mpx-view @tap="goPage" class="ad-item-container"><div class="left"><div class="title">{{config.title}}</div><div class="subtitle">{{config.subtitle}}</div><div class="btn"><div class="btn-text">{{config.btnText}}</div><mpx-image :src="(arrowRight)" class="arrow"/></div></div><div class="right"><mpx-image :src="(config.icon)" mode="widthFix" class="icon"/></div></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"ma6acfd62"}'>
  .ad-item-container
    width 350px
    height 72px
    display flex
    flex-direction row
    padding 12px 16px 14px 16px
    box-sizing border-box
    justify-content space-between
    .left
      .title
        font-family PingFangSC-Medium
        font-size 13px
        font-weight normal
        line-height 16px
        letter-spacing 0px
        color #000000
      .subtitle
        font-family PingFangSC-Regular
        font-size 10px
        font-weight normal
        line-height 12px
        letter-spacing 0px
        color #888888
        margin 2px 0 4px
      .btn
        display flex
        flex-direction row
        align-items center
        .btn-text
          font-family PingFangSC-Semibold
          font-size 11px
          font-weight normal
          line-height 13px
          letter-spacing 0px
          color #E5723A
          margin-right 3px
        .arrow
          width 5px
          height 7px
    .right
      display flex
      align-items center
      .icon
        width 48px
        height 40px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "ma6acfd62"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./ad-item.mpx.js?isComponent&outputPath=components%2Fad-itema6acfd62%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./ad-item.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fad-itema6acfd62%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["ma6acfd62"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/ad-itema6acfd62/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
